<template>
  <page-outline :title="$t('administration.user_add')">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" lg="2" xl="1">
            <back-button></back-button>
          </b-col>
        </b-row>
        <form-accordion :title="$t('administration.user_info')" :isTitleUpperCase="false">
          <div class="form-group">
          </div>
          <b-row>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="login" isMandatory
                :inputLabel="$t('administration.identifier')" :placeholderValue="$t('administration.identifier')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="name" isMandatory
                :inputLabel="$t('administration.user_name')" :placeholderValue="$t('administration.user_name')">
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="email" isMandatory
                :inputLabel="$t('administration.email')" :placeholderValue="$t('administration.email')">
              </form-write-group-label-input>
            </b-col>
            <!-- <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="password" isMandatory
                :inputLabel="$t('administration.password')" :placeholderValue="$t('administration.password')">
              </form-write-group-label-input>
            </b-col> -->
            <b-col sm="6" class="form-group">
              <label>{{ $t('administration.password') }} <span style="color: red">*</span></label>
              <div class="d-flex">
                <input v-model="password"
                  class="form-control inputAccordionForm h-30px"
                  :type="passwordType"
                  :placeholder="$t('administration.password')">
                  <div class="icon icon-password mt-2 pt-1 icon-field"
                    :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                    @click="switchPasswordType">
                  </div>
                </input>
              </div>
            </b-col>
          </b-row>
        </form-accordion>
        <br>
        <form-accordion :title="$t('administration.user_auth')" :isTitleUpperCase="false">
          <b-row class="justify-content-start">
            <b-col cols="3">
              <b-col cols="12" class="px-0">
                <label for="company-name">
                  {{ $t('administration.company_name') }}
                </label>
                <select id="select-company-name" class="form-control" v-model="idAccount">
                  <option value="" disabled>{{ $t('administration.select_company') }}</option>
                  <option v-for="(company, index) in allCompanies" :key="'filtered-profile-' + company.idAccount + '-' + index" :value="company.idAccount">
                    {{ company.name }}
                  </option>
                  <!--<option v-if="canAddAccount" value="new">Nouveau compte</option>-->
                </select>
              </b-col>
            </b-col>
            <b-col cols="3" v-if="idAccount === 'new'">
              <b-col cols="12" class="px-0">
                <label>
                  Compte de rattachement
                </label>
                <select class="form-control" v-model="idAccountParent">
                  <option value="" disabled>Selectionner le compte de rattachement</option>
                  <option v-for="(company, index) in allCompanies" :key="'filtered-profile-' + company.idAccount + '-' + index" :value="company.idAccount">
                    {{ company.name }}
                  </option>
                </select>
              </b-col>
            </b-col>
            <b-col cols="3" v-if="idAccount === 'new'">
              <form-write-group-label-input v-model="accountName" isMandatory
                inputLabel="Nom du compte" placeholderValue="Nom du compte">
              </form-write-group-label-input>
            </b-col>
            <b-col cols="3">
              <b-col cols="12" class="px-0">
                <label for="rights-profile">
                  {{ $t('administration.profile') }}
                </label>
                <select id="select-rights-profile" class="form-control" v-model="id_rights_profile">
                  <option value="" disabled>{{ $t('administration.select_profile') }}</option>
                  <option v-for="(profile, index) in AllProfiles" :key="'filtered-profile-' + profile.id + '-' + index" :value="idAccount === 'new' ? profile.name : profile.id" :disabled="profile.disabled">
                    {{ profile.name }}
                  </option>
                </select>
              </b-col>
            </b-col>
          </b-row>
        </form-accordion>
        <b-row class="mt-3 justify-content-end">
          <b-col cols="4" lg="2" xl="1">
            <b-button variant="primary"
              @click="createUser()">
              <i class="fa-light fa-save"></i>
              <span>{{ $t('common.sve') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"

import {loadPage} from '@/helpers/routing'

export default {
  name: 'AddUserCompany',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton
  },
  props: ['idCompany'],
  computed: {
    canAddAccount () {
      return this.$engine.rights.rightIs('usercompany_consult_filiale', true) || this.$engine.rights.rightIs('usercompany_consult_admin', true) || this.$engine.rights.rightIs('usercompany_add_admin', true) || this.$engine.rights.rightIs('usercompany_add_filiale', true)
    },
    filteredProfiles () {
      return this.profiles.filter(elem => {
        return !elem.libelle.includes('_SRTP') && !elem.libelle.includes('_HRTP')
      })
    },
    AllProfiles () {
      let that = this
      if (this.idAccount === 'new') {
        // à remplacer par le résultat du get template
        // le droit pour le get template doit aussi conditionner le fait de pouvoir ajouter une nouvelle company
        let existingProfile = that.profiles.find(elem => elem.idAccount === that.idAccountParent)
        return this.templates.filter(template => {
          if (existingProfile) {
            return !existingProfile.profiles.map(profile => profile.name).includes(template.name)
          }
        })
      } else {
        let existingProfile = this.profiles.find(elem => elem.idAccount === that.idAccount)
        if (existingProfile) {
          return existingProfile.profiles
        } else {
          return [{
            id: 'AccountFirst',
            name: 'Veuillez choisir un compte en premier',
            disabled: true
          }]
        }
      }
    },
    allCompanies () {
      return this.profiles.map(profile => {
          return {
            idAccount: profile.idAccount,
            name: profile.name
          }
        })
    },
    isPasswordFieldHidden () {
      return this.passwordType === 'password'
    },
    realProfileList () {
      let that = this
      const list = []
      for (const property in that.profiles) {
        const profile = that.profiles[property]
        list.push({
          tag: property,
          label: profile.libelle,
          state: profile.state,
          id: profile.id_rights_profile
        })
      }
      return list
    }
  },
  watch: {
    idAccount: function (val) {
      this.id_rights_profile = ''
    }
  },
  data () {
    return {
      active: '2',
      accountName: '',
      email: '',
      idAccount: '',
      idAccountParent: '',
      login: '',
      name: '',
      password: '',
      passwordType: 'password',
      profiles: [],
      templates: [],
      id_rights_profile: ''
    }
  },
  created () {
    let that = this
    this.$engine.rights.fetchProfileTemplate()
    .then(resp => {
      that.templates = resp.templates
    })
    .catch(err => {
      errorMessageAlert(err, that)
    })
    let userId = this.$engine.user.get().id
    // console.log(this.$engine.company)
    this.$engine.company.profiles.forEach(profile => {
      let existingProfile = that.profiles.find(obj => obj.idAccount === profile.idAccount)
      if (!existingProfile) {
        that.profiles.push({
          idAccount: profile.idAccount,
          name: profile.nameAccount,
          profiles: [{
            id: profile.id_rights_profile,
            name: profile.libelle
          }]
        })
      } else if (!existingProfile.profiles.some(obj => obj.id === profile.id_rights_profile)) {
        existingProfile.profiles.push({
          id: profile.id_rights_profile,
          name: profile.libelle
        })
      }
    })
  },
  methods: {
    createUser () {
      let that = this
      if (this.formHasError()) {
        return
      }

      let account = ''
      let profile = ''
      if (this.idAccount === 'new') {
        account = {
          Identifier: this.accountName,
          Name: this.accountName,
          EmailReference: '*',
          Active: '1',
          IdParent: this.idAccountParent
        }
        profile = [this.id_rights_profile]
      } else {
        account = this.idAccount
        profile = parseInt(this.id_rights_profile)
      }
      let user = {
        Login: this.login,
        Name: this.name,
        Active: this.active,
        Email: this.email,
        Password: this.password
      }

      this.$engine.usercompany.addUser(
        account,
        user,
        profile
      ).then(resp => {
        that.$f7.modal({
          title: that.$i18n.t('administration.user_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        //that.$bus.$emit('switch-selected-menu', '/usercompany/')
        if (that.idCompany && that.idCompany !== 'undefined') {
          loadPage(that, {url: '/detail/' + that.idCompany})
        } else {
          loadPage(that, {url: '/usercompany/'})
        }
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.$f7.modal({
          title: that.$i18n.t('administration.user_addition_error'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      })
    },
    formHasError () {
      let that = this
      if (this.login === undefined || this.login === '') {
        this.okMessageBox(this.$t('usercompany.missing_login'))
        return true
      }
      if (this.name === undefined || this.name === '') {
        this.okMessageBox(this.$t('usercompany.missing_name'))
        return true
      }
      if (this.email === undefined || this.email === '') {
        this.okMessageBox(this.$t('usercompany.missing_email'))
        return true
      }
      if (this.password === undefined || this.password === '') {
        this.okMessageBox(this.$t('usercompany.missing_password'))
        return true
      }
      if (this.id_rights_profile == '') {
        this.okMessageBox(this.$t('usercompany.missing_profile'))
        return true
      }
      return false
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchPasswordType () {
      if (this.passwordType === 'password') {
        this.passwordType = 'text'
      } else {
        this.passwordType = 'password'
      }
    }
  }
}
</script>
